import "@fontsource-variable/onest";
import "@fontsource-variable/jetbrains-mono";
import "./index.css";
import { APP_NAME } from "@custos/core";
import { Toaster } from "@custos/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { queryClient } from "./lib/api";

document.title = `${APP_NAME} Admin`;

// The admin panel uses the same saved theme rule as the web app (dark unless "light" was chosen).
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
